import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MasterMedicine } from '../types';
import { updateMasterMedicine } from '../requests';

type UpdateMasterMedicine = (id: string, data: Partial<MasterMedicine>) => Promise<void>;

interface UseUpdateMasterMedicineReturn {
  updateMasterMedicine: UpdateMasterMedicine;
  isLoading: boolean;
}

export const useUpdateMasterMedicine = (): UseUpdateMasterMedicineReturn => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ([id, update]: [string, Partial<MasterMedicine>]) => updateMasterMedicine(id, update),
    onSuccess: (_, [id]) => {
      queryClient.removeQueries(['master-medicine', id]);
    }
  });

  const updateMasterMedicineCallback = async (id: string, data: Partial<MasterMedicine>) => {
    await mutateAsync([id, data]);
  };

  return { updateMasterMedicine: updateMasterMedicineCallback, isLoading };
};
